import { LocaleName } from '@stores/locale';

export interface RouteItem {
  name: RouteName;
  title: Record<LocaleName, string>;
  path: string;
  getPath?: (params: Record<string, any>) => string;
  menuSlotes?: MenuSlotes[];
}

type MenuSlotes = 'main' | 'side';

export type RouteName =
  | 'root'
  | 'login'
  | 'userList'
  | 'userDetail'
  | 'userDetailGames'
  | 'userDetailComments'
  | 'userDetailClaims'
  | 'accountClaimsCount'
  | 'userChatClaims'
  | 'userDetailPosts'
  | 'postList'
  | 'postDetail'
  | 'postDetailLikes'
  | 'spamCommon'
  | 'spam'
  | 'spamComments'
  | 'spamUsers'
  | 'spamStatuses'
  | 'games'
  | 'promotionActivity'
  | 'tribes'
  | 'tribesMembers'
  | 'chatDetail'
  | 'promotionCommon'
  | 'promotionPush'
  | 'experiments'
  | 'promotionGames'
  | 'featuring'
  | 'mentionsOfficialAccountPost'
  | 'mentionsOfficialAccountComment'
  | 'registrationIps'
  | 'blockedEmailDomains';

const routes: Record<RouteName, RouteItem> = {
  root: {
    title: { ru_RU: 'Домашнаяя страница', en_US: 'Homepage' },
    name: 'root',
    path: '/',
  },
  login: {
    name: 'login',
    title: { ru_RU: 'Войти', en_US: 'Login' },
    path: '/login',
  },
  userList: {
    name: 'userList',
    title: { ru_RU: 'Список пользователей', en_US: 'User List' },
    path: '/user-list',
    menuSlotes: ['main'],
  },
  userDetail: {
    name: 'userDetail',
    title: { ru_RU: 'Пользователь', en_US: 'User Detail Page' },
    path: '/user-list/:userId',
  },
  userDetailGames: {
    name: 'userDetailGames',
    title: { ru_RU: 'Пользователь', en_US: 'User Games Page' },
    path: '/user-list/:userId/userGames',
  },
  userDetailComments: {
    name: 'userDetailComments',
    title: { ru_RU: 'Пользователь', en_US: 'User Comments Page' },
    path: '/user-list/:userId/comments',
  },
  userDetailClaims: {
    name: 'userDetailClaims',
    title: { ru_RU: 'Пользователь', en_US: 'User Claims Page' },
    path: '/user-list/:userId/claims',
  },
  accountClaimsCount: {
    name: 'accountClaimsCount',
    title: { ru_RU: 'Жалобы на аккаунт', en_US: 'User Claims on Account Page' },
    path: '/user-list/:userId/claims/account',
  },
  userChatClaims: {
    name: 'userChatClaims',
    title: { ru_RU: 'Подозрительные сообщения', en_US: 'Suspicious messages' },
    path: '/user-list/:userId/claims/chat',
  },
  userDetailPosts: {
    name: 'userDetailPosts',
    title: { ru_RU: 'Посты пользователя', en_US: 'User Posts Page' },
    path: '/user-list/:userId/posts/:postId',
  },
  postList: {
    name: 'postList',
    title: { ru_RU: 'Список постов', en_US: 'Post List' },
    path: '/post-list',
    menuSlotes: ['main'],
  },
  postDetail: {
    name: 'postDetail',
    title: { ru_RU: 'Пост', en_US: 'Post Detail Page' },
    path: '/post-list/:postId',
  },
  postDetailLikes: {
    name: 'postDetailLikes',
    title: { ru_RU: 'Пост', en_US: 'Post Detail Page' },
    path: '/post-list/:postId/likes',
  },
  tribes: {
    name: 'tribes',
    title: { ru_RU: 'Трайбы', en_US: 'Tribes' },
    path: '/tribes',
    menuSlotes: ['main'],
  },
  tribesMembers: {
    name: 'tribesMembers',
    title: { ru_RU: 'Участники трайбов', en_US: 'Tribes members' },
    path: '/tribes/members/:tribeId',
  },
  chatDetail: {
    name: 'chatDetail',
    title: { ru_RU: 'Чат', en_US: 'Chat' },
    path: '/tribes/chats/:chatId',
  },
  featuring: {
    name: 'featuring',
    title: { ru_RU: 'Фичеринг', en_US: 'Featuring' },
    path: '/promotion/featuring',
  },
  promotionActivity: {
    name: 'promotionActivity',
    title: { ru_RU: 'Нотификации', en_US: 'Notification' },
    path: '/promotion-activity',
  },
  promotionGames: {
    name: 'promotionGames',
    title: { ru_RU: 'Игры', en_US: 'Games' },
    path: '/promotion-games',
  },
  promotionCommon: {
    name: 'promotionCommon',
    title: { ru_RU: 'Промо', en_US: 'Promotion' },
    path: '/promotion',
    menuSlotes: ['main'],
  },
  spamCommon: {
    name: 'spamCommon',
    title: { ru_RU: 'Модерация', en_US: 'Moderation' },
    path: '/spam',
    menuSlotes: ['main'],
  },
  spam: {
    name: 'spam',
    title: { ru_RU: 'Модерация постов', en_US: 'Spam posts' },
    path: '/spam/posts',
  },
  spamComments: {
    name: 'spamComments',
    title: { ru_RU: 'Модерация комментариев', en_US: 'Spam Comments' },
    path: '/spam/comments',
  },
  spamUsers: {
    name: 'spamUsers',
    title: { ru_RU: 'Модерация пользователей', en_US: 'Spam Users' },
    path: '/spam/users',
  },
  spamStatuses: {
    name: 'spamStatuses',
    title: { ru_RU: 'Модерация статусов', en_US: 'Spam Statuses' },
    path: '/spam/statuses',
  },
  games: {
    name: 'games',
    title: { ru_RU: 'Игры', en_US: 'Games' },
    path: '/games',
    menuSlotes: ['main'],
  },
  promotionPush: {
    name: 'promotionPush',
    title: { ru_RU: 'Пуши', en_US: 'Push' },
    path: '/push',
    menuSlotes: ['main'],
  },
  experiments: {
    name: 'experiments',
    title: { ru_RU: 'Эксперименты', en_US: 'Experiments' },
    path: '/experiments',
    menuSlotes: ['main'],
  },

  mentionsOfficialAccountPost: {
    name: 'mentionsOfficialAccountPost',
    title: { ru_RU: 'Лента', en_US: 'Feed' },
    path: '/official-account/post',
    menuSlotes: ['main'],
  },
  mentionsOfficialAccountComment: {
    name: 'mentionsOfficialAccountComment',
    title: { ru_RU: 'Лента', en_US: 'Feed' },
    path: '/official-account/comment',
  },
  registrationIps: {
    name: 'registrationIps',
    title: { ru_RU: 'IP регистрации', en_US: 'Registration IPs' },
    path: '/registration-ips',
    menuSlotes: ['main'],
  },
  blockedEmailDomains: {
    name: 'blockedEmailDomains',
    title: { ru_RU: 'Черный список доменов', en_US: 'Domain blacklist' },
    path: '/blocked-email-domains',
    menuSlotes: ['main'],
  },
};

export default routes;

export const mainRoutes: string[] = [
  'userList',
  'postList',
  'tribes',
  'promotionCommon',
  'spamCommon',
  'games',
];
